// extracted by mini-css-extract-plugin
export default {"wrapper":"CookiesModal_wrapper__HBZFj","button_footer":"CookiesModal_button_footer__omdVN","accept_button":"CookiesModal_accept_button__DKNpr"};